import { initReactI18next } from "react-i18next";
import {
  englishTranslations,
  hungarianTranslations,
} from "./i18n-translations";
import i18n, { InitOptions } from "i18next";
import Backend from "i18next-xhr-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "hu",
    debug: false,
    interpolation: {
      escapeValue: false,
      format: (
        value: unknown,
        _format?: string,
        lng?: string,
      ): string | unknown => {
        if (value instanceof Date) {
          return value.toLocaleDateString(lng, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          });
        }
        return value;
      },
    },
    resources: {
      en: {
        translation: englishTranslations,
      },
      hu: {
        translation: hungarianTranslations,
      },
    },
    load: "languageOnly",
    whitelist: ["hu", "en"], // List of supported languages
    nonExplicitWhitelist: true,
    detection: { checkWhitelist: true },
    react: {
      useSuspense: false,
    },
  } as InitOptions);

const language: string =
  window?.navigator?.language?.substr(0, 2).toLowerCase() || "hu";

i18n.changeLanguage(language);

export default i18n;
